import { Injectable, Type } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  public setItem(params: { key: string, value: any }): void {
    localStorage.setItem(params.key, params.value);
  }

  public getItem(params: { key: string }) {
    const value = localStorage.getItem(params.key);

    if (!value) return null;

    return JSON.parse(value);
  }

  public removeItem(params: { key: string }) {
    localStorage.removeItem(params.key);
  }

}
